import {
  classifyPath,
  getFirstTouchAttribution,
  getFirstTouchLanding,
} from "@/lib/landing-cluster";

function nonBlank(value: string | null | undefined): string | undefined {
  const normalized = value?.trim();
  return normalized || undefined;
}

export function paymentLandingAttribution(data: {
  source_path?: string;
  landing_cluster?: string;
  landing_path?: string;
}) {
  const firstTouch = getFirstTouchLanding();
  const governedFirstTouch = getFirstTouchAttribution();
  const clickPath =
    nonBlank(data.source_path) ??
    (typeof window !== "undefined" ? window.location.pathname || undefined : undefined);
  const landingPath = nonBlank(data.landing_path) ?? nonBlank(firstTouch.path) ?? clickPath;
  return {
    ...(governedFirstTouch ?? {}),
    landing_path: landingPath,
    landing_cluster:
      nonBlank(data.landing_cluster) ??
      nonBlank(firstTouch.cluster) ??
      (landingPath ? classifyPath(landingPath) : undefined),
  };
}
